import { IconButton, Menu } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { uniqueId } from 'lodash';
import { useState } from 'react';
import { styled } from '@mui/material/styles';

type Props = {
  children: React.ReactNode;
  stopPropagation?: boolean;
  noPadding?: boolean;
  color?:
    | 'inherit'
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
};

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'noPadding',
})<{
  noPadding?: boolean;
  color?:
    | 'inherit'
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
}>(({ noPadding, color }) => ({
  padding: noPadding ? 0 : undefined,
  color,
}));

const Actions: React.FC<Props> = ({
  children,
  stopPropagation = false,
  noPadding = false,
  color,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuId = uniqueId('actions-');
  const buttonId = uniqueId('actions-button-');

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    handleClose();
  };

  return (
    <div>
      <StyledIconButton
        aria-label="more"
        id={buttonId}
        aria-controls={anchorEl ? menuId : undefined}
        aria-expanded={anchorEl ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleOpen}
        size="large"
        noPadding={noPadding}
        color={color}
      >
        <MoreVert />
      </StyledIconButton>
      <Menu
        MenuListProps={{
          'aria-labelledby': buttonId,
        }}
        onClick={handleMenuClick}
        id={menuId}
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
      >
        {children}
      </Menu>
    </div>
  );
};

export default Actions;
